import PortfolioParallaxContainer from "../../../../components/pages/portfolio/portfolioPage/PortfolioParallax";

const PortfolioParallax = () => {
  return <PortfolioParallaxContainer />;
};

export default PortfolioParallax;
